/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2021-12-04 13:51:00
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-23 15:44:18
 */
const getDefaultState = () => {
  return {
    refreshToken: "",
    token: "",
    name: "",
    avatar: "",
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  LOGOUT: (state) => {
    state.token = "";
    state.refreshToken = "";
  },
};

const actions = {
  logout({ commit }) {
    commit("LOGOUT");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
